"use strict";
/**
 * Реалізація галереї з використанням делегування подій.
 * Ми вішаємо один обробник на батьківський елемент 'thumbs',
 * замість того, щоб додавати його до кожного посилання окремо.
 */ // шукаємо контейнер з мініатюрами (батьківський елемент)
var thumbs = document.getElementById("thumbs");
// вішаємо слухач подій на весь контейнер
thumbs.addEventListener("click", function(evnt) {
    // юзаємо .closest('a'), щоб знайти найближче посилання.
    // спрацює, навіть якщо юзер натиснув на <img> всередині <a>.
    var link = evnt.target.closest("a");
    // провіряємо чи клік дійсно відбувся по посиланню всередині списку
    // якщоклікнули на порожнє місце в <ul>, метод поверне null, і ми вийдемо
    if (!link) return;
    // відміняємо стандартну поведінку браузера.
    // без цього браузер відкриє картинку окремою сторінкою=>
    // => (перейде за посиланням).
    evnt.preventDefault();
    // шукаємо елемент великої картинки в DOM
    var largeImg = document.getElementById("largeImg");
    // oновлюємо атрибут 'src' великої картинки
    // беремо значення з атрибута 'href' того посилання по якому був клік
    largeImg.src = link.href;
});

//# sourceMappingURL=index.cb7636bb.js.map
